
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.12","height":"17.585"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Контур 34857","d":"M11.174 17.586H2.015A2.017 2.017 0 010 15.571V5.679a2.017 2.017 0 012.015-2.015h.366a.55.55 0 010 1.1h-.366a.917.917 0 00-.916.916v9.892a.917.917 0 00.916.916h9.159a.917.917 0 00.916-.916v-.366a.55.55 0 111.1 0v.366a2.017 2.017 0 01-2.016 2.014zm0 0","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Контур 34858","d":"M14.105 13.189H6.411a2.017 2.017 0 01-2.015-2.015V2.015A2.017 2.017 0 016.411 0h7.694a2.017 2.017 0 012.015 2.015v9.159a2.017 2.017 0 01-2.015 2.015zM6.411 1.1a.917.917 0 00-.916.916v9.159a.917.917 0 00.916.916h7.694a.917.917 0 00.916-.916v-9.16a.917.917 0 00-.916-.916zm0 0","fill":"#fff"}})])
          )
        }
      }
    